module.exports = __webpack_public_path__ + "static/media/S-9.27dcbda2.mp3";